import React, { useRef, useState, useEffect } from 'react';
import { Box } from '@mui/material';
import OperatorCard from './OperatorCard';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';

const API_URL = process.env.REACT_APP_API_ROOT || 'http://localhost:4000';

const OperatorCarousel = ({ updateExpression, expression }) => {
    const [operators, setOperators] = useState([]);
    const { getAccessTokenSilently } = useAuth0();

    useEffect(() => {
        const fetchOperators = async () => {
            const token = await getAccessTokenSilently();
            axios.get(`${API_URL}/api/simulations/operators`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
                .then(response => setOperators(response.data))
                .catch(error => {
                    console.error("Failed to fetch operators:", error);
                });
        };
        fetchOperators();
    }, [getAccessTokenSilently]);

    const carouselRef = useRef(null);

    useEffect(() => {
        const carousel = carouselRef.current;
        if (!carousel) return;
        const onWheel = (event) => {
            event.preventDefault(); // Now works since listener is non-passive
            event.stopPropagation();
            carousel.scrollLeft += event.deltaY;
        };
        carousel.addEventListener('wheel', onWheel, { passive: false });
        return () => {
            carousel.removeEventListener('wheel', onWheel);
        };
    }, []);

    return (
        <Box
            ref={carouselRef}
            sx={{
                display: 'flex',
                overflowX: 'auto',
                overflowY: 'hidden', // disable vertical scrolling on carousel
                overscrollBehavior: 'contain', // confine scroll events to this component
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: 2,
                p: 1,
            }}
        >
            {operators.map(operator => (
                <div key={operator.id}>
                    <OperatorCard operator={operator} />
                </div>
            ))}
        </Box>
    );
};

export default OperatorCarousel;